import { chakra, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import {
  OPEN_ROW_BUTTON_CLASS,
  useDateTimeCellStyles,
} from '~/pages/Calls/componentStyles/CallsListItem.style'

interface DateTimeCellProps {
  date: string
  time: string
  columnStyles: Record<string, any>
  role?: React.AriaRole
  /** When set, the date and time render as a button that opens the row. */
  onOpen?: () => void
  openLabel?: string
  isCurrent?: boolean
}
export const DateTimeCell = ({
  columnStyles,
  date,
  time,
  role,
  onOpen,
  openLabel,
  isCurrent,
}: DateTimeCellProps) => {
  const styles = useDateTimeCellStyles()
  const content = (
    <>
      <Text as="span" css={styles.timeText}>
        {time}
      </Text>
      <Flex
        as="span"
        css={styles.timeWrapper}
        alignItems="center"
        gap="0.25rem"
      >
        <Text as="span" css={styles.dateText}>
          {date}
        </Text>
      </Flex>
    </>
  )

  if (!onOpen) {
    return (
      <Flex role={role} css={{ ...columnStyles, ...styles.container }}>
        {content}
      </Flex>
    )
  }

  return (
    <Flex role={role} css={{ ...columnStyles, ...styles.container }}>
      <chakra.button
        type="button"
        className={OPEN_ROW_BUTTON_CLASS}
        aria-label={openLabel}
        aria-current={isCurrent ? 'true' : undefined}
        onClick={(event) => {
          event.stopPropagation()
          onOpen()
        }}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        textAlign="start"
        cursor="pointer"
        _focusVisible={{ outline: 'none' }}
      >
        {content}
      </chakra.button>
    </Flex>
  )
}
